import './nav.css';
import { Link, NavLink } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faHome,
  faBuilding,
  faEnvelope,
  faShoppingCart
} from '@fortawesome/free-solid-svg-icons';
//import { FaMicrophoneAlt } from 'react-icons/fa';
import TrmValue from '../trm/Trm';
import { useState } from 'react';

function Navbar() {
  const [isOpen, setIsOpen] = useState(false);

  const handleToggle = () => setIsOpen(!isOpen);
  const closeMenu = () => setIsOpen(false);

  const navLinkClass = ({ isActive }) =>
    `nav-link${isActive ? ' active' : ''}`;

  return (
    <nav className="navbar navbar-expand-lg navbar-dark custom-navbar">
      <div className="container-fluid px-4">
        <Link
          className="navbar-brand fw-bold d-flex align-items-center gap-2"
          to="/"
          onClick={closeMenu}
        >
          <span className="logo-shell">
            <img src="/images/discoVPA.png" alt="logo" className="logo" />
          </span>
          <span className="brand-copy">
            <small>Vintage Pro</small>
            <strong>Audio Colombia</strong>
          </span>
        </Link>

        <button
          className="navbar-toggler"
          type="button"
          aria-controls="navbarNav"
          aria-expanded={isOpen ? 'true' : 'false'}
          aria-label="Toggle navigation"
          onClick={handleToggle}
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div
          className={`navbar-collapse navbar-collapse-custom ${
            isOpen ? 'show' : ''
          }`}
          id="navbarNav"
        >
          <ul className="navbar-nav ms-auto text-center align-items-lg-center">
            <li className="nav-item nav-trm-item">
              <div className="nav-trm-chip">
                <TrmValue />
              </div>
            </li>

            <li className="nav-item">
              <NavLink className={navLinkClass} to="/" onClick={closeMenu} end>
                <FontAwesomeIcon icon={faHome} className="me-1" /> Home
              </NavLink>
            </li>

            <li className="nav-item">
              <NavLink className={navLinkClass} to="/about" onClick={closeMenu}>
                <FontAwesomeIcon icon={faBuilding} className="me-1" /> About
              </NavLink>
            </li>

            <li className="nav-item">
              <NavLink className={navLinkClass} to="/contacto" onClick={closeMenu}>
                <FontAwesomeIcon icon={faEnvelope} className="me-1" /> Contacto
              </NavLink>
            </li>

            <li className="nav-item">
              <NavLink className={navLinkClass} to="/tienda" onClick={closeMenu}>
                <FontAwesomeIcon icon={faShoppingCart} className="me-1" /> Tienda
              </NavLink>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
